import {PlannerGroup} from '@domain/shifthandover'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

const QueryKey = 'planner-groups'

export const usePlannerGroups = (plantId: string) => {
  return useQuery({
    queryKey: [QueryKey, plantId],
    queryFn: async () => {
      const {data} = await ApiClient.axiosInstance.get<PlannerGroup[]>(
        `/plantconfig/${plantId}/planner-groups`
      )
      return data
    }
  })
}
